import { clickOpenText } from "../../../../themes/custom/ev_theme/frontend/js/common/constants/variables/globalVariables";
import { initMap } from "../../../../themes/custom/ev_theme/frontend/js/components/loadMap";
import { addItemToCompare, closeCompare, loadCompare, seeSummaryCards, showComparatorSection, uncheckAll } from "./components/comparator";
import { addselect, backOtherFilter, clearFilter, nextOtherFilter, openFilter } from "./components/filters/filters";
import { getValuesUpdated } from "./components/filters/sliderRange";
import { filterString } from "./components/results-load/results-query";
import { closeMap, openMap } from "./components/map";
import { closeFilterOrderMobile, loadAds, loadCertificate, loadMoreResults, openBuilderProjects, toggleFilterOrder } from "./components/script";
import { loadResultsData } from "./components/results-load/results-load";
window.filterString = filterString;
window.clearFilter = clearFilter;
window.openFilter = openFilter;
window.addselect = addselect;
window.getValuesUpdated = getValuesUpdated;
window.toggleFilterOrder = toggleFilterOrder;
window.closeFilterOrderMobile = closeFilterOrderMobile;
window.openBuilderProjects = openBuilderProjects;
window.loadMoreResults = loadMoreResults;
window.clickOpenText = clickOpenText;
window.nextOtherFilter = (item, list) => {
    nextOtherFilter(item, list);
};
window.backOtherFilter = (item, list) => {
    backOtherFilter(item, list);
};
// comparator
window.closeCompare = closeCompare;
window.loadCompare = loadCompare;
window.seeSummaryCards = seeSummaryCards;
window.addItemToCompare = addItemToCompare;
window.showComparatorSection = showComparatorSection;
window.uncheckAll = uncheckAll;
// map
window.initMap = initMap;
window.openMap = openMap;
window.closeMap = closeMap;
/**
 * Function to initialize and load data when not in builder mode
 */
function initializePage() {
    // false indicates that the builder feature is not being used
    loadResultsData();
    // Load advertisements on the page
    loadAds();
    initializeReadMore();
}
function initializeReadMore() {
    const btns = Array.from(document.getElementsByClassName('js-hide-action'));
    btns.forEach(btn => btn.addEventListener('click', clickOpenText));
}
// Load data and components on page initialization
initializePage();
window.app = Vue.createApp({
    delimiters: ['${', '}'],
    data() {
        return {
            datos: [],
            datos1: [],
            featuredProjects: [],
            isOutletPage: false,
        };
    },
    mounted() {
        const el = document.getElementById('app');
        this.isOutletPage = (el === null || el === void 0 ? void 0 : el.dataset.isOutlet) === '1';
    },
    methods: {
        setFormat(number) {
            let formatted = new Intl.NumberFormat("es-CO", {
                style: 'currency',
                currency: "COP",
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            }).format(number);
            return formatted;
        },
    },
}).mount('#app');
/**
 * Event listener to handle DOM content loaded
 */
document.addEventListener('DOMContentLoaded', () => {
    // Enable buttons on the project card footer
    enableContactButtons();
    // Show or hide the WhatsApp button based on URL and screen width
    handleWhatsAppButtonVisibility();
    // Load certificates based on the current URL
    const currentUrl = window.location.href;
    const urlPerSection = currentUrl.split('/');
    loadCertificate(urlPerSection);
});
/**
 * Enables the contact buttons by removing the 'disabled' attribute
 */
function enableContactButtons() {
    const buttonContact = document.querySelectorAll('.project-card__footer .primary-btn');
    buttonContact.forEach(button => {
        button.removeAttribute('disabled');
    });
}
/**
 * Toggles the visibility of the WhatsApp button based on screen width and URL section
 */
function handleWhatsAppButtonVisibility() {
    const currentUrl = window.location.href;
    const urlPerSection = currentUrl.split('/');
    const whatsappBot = document.getElementById('block-whatsappbot');
    if (window.innerWidth < 480 && urlPerSection[3] === "proyectos-vivienda") {
        whatsappBot === null || whatsappBot === void 0 ? void 0 : whatsappBot.classList.add('d-none');
    }
    else {
        whatsappBot === null || whatsappBot === void 0 ? void 0 : whatsappBot.classList.remove('d-none');
    }
}
